import { render, staticRenderFns } from "./ClassFormModal.vue?vue&type=template&id=2db266ad&scoped=true"
import script from "./ClassFormModal.vue?vue&type=script&lang=js"
export * from "./ClassFormModal.vue?vue&type=script&lang=js"
import style0 from "./ClassFormModal.vue?vue&type=style&index=0&id=2db266ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db266ad",
  null
  
)

export default component.exports